import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Navbar() {
  return (
    <header className="nav">
      <div className="container nav-inner">
        
        {/* LOGO + TITULO */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img
            src={logo}
            alt="El Show de las Banqueras"
            style={{
              height: 56,
              width: 56,
              objectFit: "contain",
              borderRadius: 16,
              background: "rgba(255,255,255,.08)",
              padding: 6
            }}
          />

          <div>
            <div style={{ fontWeight: 900 }}>
              El Show de las <span style={{ color: "var(--gold)" }}>Banqueras</span>
            </div>
            <div
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,.65)"
              }}
            >
              Podcast • Entretenimiento • Comunidad
            </div>
          </div>
        </div>

        {/* MENU */}
        <nav className="nav-links">
          <NavLink to="/">Inicio</NavLink>
          <NavLink to="/sobre-nosotros">Sobre Nosotros</NavLink>
          <NavLink to="/contactos">Contactos</NavLink>
          <NavLink to="/empleo">Empleo</NavLink>
        </nav>
      </div>
    </header>
  );
}
